"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.json.stringify.js");
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _elementUi = require("element-ui");
var _data = require("@api/system/dict/data");
var _sysConfig = require("@api/system/sysConfig");
var _checkCache = require("@api/business/common/checkCache");
var _login = require("@api/login");
// import { formatDate } from '@/utils/wl-utils'

_nprogress.default.configure({
  showSpinner: false
});
var whiteList = ['/login', '/auth-redirect', '/bind', '/register'];
_router.default.beforeEach(function (to, from, next) {
  var _to$matched$;
  _nprogress.default.start();

  // if (to.query.code) {
  //   if (sessionStorage.getItem('login_code') && sessionStorage.getItem('login_code') == to.query.code) {
  //     console.log('重复')
  //   } else {
  //     sessionStorage.setItem('login_code', to.query.code)
  //     tokenLogin(to.query.code)
  //       .then(response => {
  //         if (response.token === '0') {
  //         } else if (response.token === '1') {
  //           Notification({
  //             title   : '该用户不是系统用户',
  //             message : '该用户不是系统用户',
  //             type    : 'error',
  //             duration: 10 * 1000
  //           })
  //         } else if (response.token === '2') {
  //           next({ path: '/' })
  //         } else {
  //           setToken(response.token)
  //           next({ path: '/' })
  //         }
  //       })
  //       .catch(error => {
  //         console.error('tokenLogin失败: ', error);
  //       })
  //   }
  // }
  if (((_to$matched$ = to.matched[0]) === null || _to$matched$ === void 0 ? void 0 : _to$matched$.path) === '/fromt-desk') {
    next();
  } else if ((0, _auth.getToken)()) {
    /* has token*/
    if (to.path === '/login') {
      next({
        path: '/'
      });
      _nprogress.default.done();
    } else {
      if (_store.default.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        _store.default.dispatch('GetInfo').then(function (res) {
          // 查询系统参数配置并缓存
          (0, _sysConfig.getSystemConfig)().then(function (response) {
            sessionStorage.setItem('systemConfig', JSON.stringify(response.data));
          });
          // 查询系统字典配置并缓存
          (0, _data.findAllDict)().then(function (response) {
            sessionStorage.setItem('dicts', JSON.stringify(response.data));
          });
          // 查询系统参数配置并缓存
          (0, _checkCache.getConfigErpKey)().then(function (response) {
            sessionStorage.setItem('mesSyncErp', response.message);
          });
          // 拉取user_info
          var roles = res.roles;
          _store.default.dispatch('GenerateRoutes', {
            roles: roles
          }).then(function (accessRoutes) {
            // 测试 默认静态页面
            // store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            _router.default.addRoutes(accessRoutes); // 动态添加可访问路由表
            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
              replace: true
            })); // hack方法 确保addRoutes已完成
          });
        }).catch(function (err) {
          _store.default.dispatch('FedLogOut').then(function () {
            _elementUi.Message.error(err);
            next({
              path: '/'
            });
          });
        });
      } else {
        next();
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.roles, to.meta.roles)) {
        //   next()
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        // }
        // 可删 ↑
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next("/login?redirect=".concat(to.path)); // 否则全部重定向到登录页
      _nprogress.default.done();
    }
  }
});
_router.default.afterEach(function () {
  _nprogress.default.done();
});